import request from '@/utils/request'

// 开发者注册
export function developerReg (data) {
  return request({
    url: '/apis/dra/devc/users/signup/developerRegistration', // 后端接口
    method: 'post',
    data
  })
}

// 附件上传
export function uploadFile (data) {
  return request({
    url: '/apis/dra/oss/users/signup/uploadFileToOss', // 后端接口
    method: 'post',
    data
  })
}

// 获取手机验证码
export function sendVerCode (data) {
  return request({
    url: '/apis/dra/devc/users/signup/newSendVerCode',
    method: 'post',
    data
  })
}

// 开发者修改
export function updateDeveloper (data) {
  return request({
    url: '/apis/dra/devc/users/signup/updateDeveloper', // 后端接口
    method: 'post',
    data
  })
}

// 开发者信息查询
export function qryDeveloperInfo (data) {
  return request({
    url: '/apis/dra/devc/users/signup/qryDeveloperInfo', // 后端接口
    method: 'post',
    data
  })
}
// 验证
export function confirmCode (data) {
  return request({
    url: '/apis/dra/devc/users/signup/checkMessage', // 后端接口
    method: 'post',
    data
  })
}
// 获取证件类型
export function getIDtype (data) {
  return request({
    url: '/apis/dra/common/users/signup/qryDictByCode', // 后端接口
    method: 'post',
    data
  })
}
//获取拼图滑块图片验证
export function getImageVerifyCode (data) {
  return request({
    url: '/apis/dra/captcha/users/signup/getImageVerifyCode.do', // 后端接口
    method: 'get',
    data
  })
}
